export const getLocaleMessages = (locale: string) =>
  import(/* webpackChunkName: "[request]" */ `./translations/${locale}.json`).then((module) => module.default);

export const formatLocale = (locale?: string): string | undefined => {
  return locale?.replace(/_/g, '-');
};
